// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HUvcg","newExpiryDate":"styles_newExpiryDate__z1tCv","footer":"styles_footer__2fzNs"};